var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"three-dots-loader",style:(_vm.loaderStyle)},_vm._l((_vm.dotsAmount),function(index){return _c('span',{style:(_vm.dotStyle)},[_vm._v(".")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }